import produce from 'immer'

import {
  FETCH_BRANDS,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
  FETCH_VERSIONS,
  FETCH_VERSIONS_SUCCESS,
  FETCH_VERSIONS_FAILURE,
  FETCH_CONTENT_TYPES,
  FETCH_CONTENT_TYPES_SUCCESS,
  FETCH_CONTENT_TYPES_FAILURE,
  FETCH_BRAND_STATUS,
  FETCH_BRAND_STATUS_SUCCESS,
  FETCH_BRAND_STATUS_FAILURE,
  FETCH_BRAND_PROGRESS,
  FETCH_BRAND_PROGRESS_SUCCESS,
  FETCH_BRAND_PROGRESS_FAILURE,
  REINDEX_BRAND,
  REINDEX_BRAND_SUCCESS,
  REINDEX_BRAND_FAILURE,
  STOP_REINDEX,
  STOP_REINDEX_SUCCESS,
  STOP_REINDEX_FAILURE,
  REINDEX_BY_ID,
  REINDEX_BY_ID_SUCCESS,
  REINDEX_BY_ID_FAILURE,
  SET_VERSIONS,
  SET_VERSIONS_SUCCESS,
  SET_VERSIONS_FAILURE,
  SET_CONTENT_TYPES,
} from '../actions/types'

export const initialProgressStatusState = {
  message: '',
  running: false,
  error: false,
  progress: 0,
  total: 0,
  finished: false,
  cancelled: false,
}

export const initialBrandState = {
  fullName: '',
  brand: '',
  indexName: false,
  providers: [],
  indexedCount: 0,
  totalCount: 0,
  percentage: 0,
  progressStatus: initialProgressStatusState,

  statusFetching: false,
  statusFetched: false,
  statusError: null,

  progressFetching: false,
  progressFetched: false,
  progressError: null,
}

export const initialState = {
  brandsAllIds: [],
  brandsById: {},
  brandsFetching: false,
  brandsFetched: false,
  brandsError: null,

  contentTypes: [],
  selectedContentTypes: [],
  contentTypesFetching: false,
  contentTypesFetched: false,
  contentTypesError: null,

  versions: [],
  versionsFetching: false,
  versionsFetched: false,
  versionsError: null,

  reindexBrandPending: false,
  reindexBrandSuccess: false,
  reindexBrandError: null,

  stopReindexPending: false,
  stopReindexSuccess: false,
  stopReindexError: null,

  reindexByIdPending: false,
  reindexByIdSuccess: false,
  reindexByIdError: null,

  setVersionsPending: false,
  setVersionsSuccess: false,
  setVersionsError: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_BRANDS: {
      draft.brandsFetching = true
      break
    }
    case FETCH_BRANDS_SUCCESS: {
      const brands = payload
      draft.brandsError = null
      draft.brandsFetching = false
      draft.brandsFetched = true
      draft.brandsAllIds = []
      draft.brandsById = {}
      brands.forEach((brand) => {
        draft.brandsAllIds.push(brand.brand)
        draft.brandsById[brand.brand] = { ...initialBrandState, ...brand }
      })

      break
    }
    case FETCH_BRANDS_FAILURE: {
      const error = payload
      draft.brandsError = error
      draft.brandsFetching = false
      draft.brandsFetched = true
      break
    }
    case FETCH_VERSIONS: {
      draft.versionsFetching = true
      break
    }
    case FETCH_VERSIONS_SUCCESS: {
      const versions = payload
      draft.versionsError = null
      draft.versionsFetching = false
      draft.versionsFetched = true
      draft.versions = versions
      break
    }
    case FETCH_VERSIONS_FAILURE: {
      const error = payload
      draft.versionsError = error
      draft.versionsFetching = false
      draft.versionsFetched = true
      break
    }
    case FETCH_CONTENT_TYPES: {
      draft.contentTypesFetching = true
      break
    }
    case FETCH_CONTENT_TYPES_SUCCESS: {
      const contentTypes = payload
      draft.contentTypesError = null
      draft.contentTypesFetching = false
      draft.contentTypesFetched = true
      draft.contentTypes = contentTypes
      break
    }
    case FETCH_CONTENT_TYPES_FAILURE: {
      const error = payload
      draft.contentTypesError = error
      draft.contentTypesFetching = false
      draft.contentTypesFetched = true
      break
    }
    case FETCH_BRAND_STATUS: {
      const { brandName } = payload
      const brand = draft.brandsById[brandName]
      brand.statusFetching = true
      break
    }
    case FETCH_BRAND_STATUS_SUCCESS: {
      const { brandName, data } = payload
      const { indexedCount, totalCount, percentage, progressStatus } = data
      const brand = draft.brandsById[brandName]
      brand.statusError = null
      brand.statusFetching = false
      brand.statusFetched = true

      brand.indexedCount = indexedCount
      brand.totalCount = totalCount
      brand.percentage = percentage
      brand.progressStatus = progressStatus
      break
    }
    case FETCH_BRAND_STATUS_FAILURE: {
      const { brandName, error } = payload
      const brand = draft.brandsById[brandName]
      brand.statusError = error
      brand.statusFetching = false
      brand.statusFetched = true
      break
    }
    case FETCH_BRAND_PROGRESS: {
      const brandName = payload
      const brand = draft.brandsById[brandName]
      brand.progressFetching = true
      break
    }
    case FETCH_BRAND_PROGRESS_SUCCESS: {
      const { brandName, data } = payload
      const { message, running, error, progress, total, finished, cancelled } = data
      const brand = draft.brandsById[brandName]
      brand.progressError = null
      brand.progressFetching = false
      brand.progressFetched = true

      brand.progressStatus.message = message
      brand.progressStatus.running = running
      brand.progressStatus.error = error
      brand.progressStatus.progress = progress
      brand.progressStatus.total = total
      brand.progressStatus.finished = finished
      brand.progressStatus.cancelled = cancelled
      break
    }
    case FETCH_BRAND_PROGRESS_FAILURE: {
      const { brandName, error } = payload
      const brand = draft.brandsById[brandName]
      brand.progressError = error
      brand.progressFetching = false
      brand.progressFetched = true
      break
    }
    case REINDEX_BRAND: {
      draft.reindexBrandPending = true
      break
    }
    case REINDEX_BRAND_SUCCESS: {
      draft.reindexBrandError = null
      draft.reindexBrandPending = false
      draft.reindexBrandSuccess = true
      break
    }
    case REINDEX_BRAND_FAILURE: {
      const { error } = payload
      draft.reindexBrandError = error
      draft.reindexBrandPending = false
      draft.reindexBrandSuccess = false
      break
    }
    case STOP_REINDEX: {
      draft.stopReindexPending = true
      break
    }
    case STOP_REINDEX_SUCCESS: {
      draft.stopReindexError = null
      draft.stopReindexPending = false
      draft.stopReindexSuccess = true
      break
    }
    case STOP_REINDEX_FAILURE: {
      const { error } = payload
      draft.stopReindexError = error
      draft.stopReindexPending = false
      draft.stopReindexSuccess = false
      break
    }
    case REINDEX_BY_ID: {
      draft.reindexByIdPending = true
      break
    }
    case REINDEX_BY_ID_SUCCESS: {
      draft.reindexByIdError = null
      draft.reindexByIdPending = false
      draft.reindexByIdSuccess = true
      break
    }
    case REINDEX_BY_ID_FAILURE: {
      const error = payload
      draft.reindexByIdError = error
      draft.reindexByIdPending = false
      draft.reindexByIdSuccess = false
      break
    }
    case SET_VERSIONS: {
      draft.setVersionsPending = true
      break
    }
    case SET_VERSIONS_SUCCESS: {
      draft.setVersionsError = null
      draft.setVersionsPending = false
      draft.setVersionsSuccess = true
      break
    }
    case SET_VERSIONS_FAILURE: {
      const error = payload
      draft.setVersionsError = error
      draft.setVersionsPending = false
      draft.setVersionsSuccess = false
      break
    }
    case SET_CONTENT_TYPES: {
      draft.selectedContentTypes = payload
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
